import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails, Button } from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { FAQ_CONTENT } from "../content/faq";
import { Lang } from "../content/mutualiteiten";
import { pageTitle, lead, h2Rule, ctaSx, fadeUp } from "../theme/marketingStyles";

/** /veelgestelde-vragen — antwoorden consistent met de legal pages en de
 *  werkelijke werking (zie content/faq.ts). Accordions in de stille
 *  scheidingslijn-stijl van de homepage-preview. */
export default function Faq() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const lang = ((i18n.language || "nl").slice(0, 2) as Lang);
  const content = FAQ_CONTENT[lang] || FAQ_CONTENT.nl;

  return (
    <Box sx={{ bgcolor: "background.default" }}>
      <Container maxWidth="md" sx={{ pt: { xs: 6, sm: 9 }, pb: { xs: 7, sm: 10 } }}>
        <Box sx={{ textAlign: { xs: "center", md: "left" }, ...fadeUp(0) }}>
          <Typography variant="h1" sx={pageTitle}>{content.title}</Typography>
          <Typography sx={{ ...lead, maxWidth: 640, mx: { xs: "auto", md: 0 } }}>{content.intro}</Typography>
        </Box>

        {content.groups.map((group) => (
          <Box key={group.title} sx={{ mb: 2 }}>
            <Typography variant="h2" sx={{ ...h2Rule, mt: 5, mb: 1 }}>{group.title}</Typography>
            {group.items.map((item) => (
              <Accordion key={item.id} disableGutters elevation={0}
                sx={{ bgcolor: "transparent", borderBottom: "1px solid var(--border)", "&:before": { display: "none" }, "&.Mui-expanded": { m: 0 } }}>
                <AccordionSummary expandIcon={<ExpandMoreRoundedIcon />} sx={{ px: 0, py: 0.75, "& .MuiAccordionSummary-content": { my: 1 } }}>
                  <Typography sx={{ fontWeight: 600, m: 0, color: "text.primary" }}>{item.q}</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ px: 0, pt: 0, pb: 2.5 }}>
                  {item.a.map((p, i) => (
                    <Typography key={i} sx={{ mb: i < item.a.length - 1 ? 1.5 : 0, color: "text.secondary", lineHeight: 1.7 }}>{p}</Typography>
                  ))}
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        ))}

        <Box sx={{ mt: 7, textAlign: "center" }}>
          <Typography sx={{ mb: 2, color: "text.secondary" }}>{t("faqPage.ctaLead")}</Typography>
          <Button variant="contained" size="large" onClick={() => navigate("/start")} sx={{ minWidth: 240, ...ctaSx }}>
            {t("faqPage.cta")}
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
